import {Image2} from "../../assets";
import FaqComponentView from "../faq/faqComponentView";
import {setupFAQs} from "../../static-data/allFAQs";
import MainCTA from "../CTA-sections/mainCTA";

export default function OnsiteSEOComponent(props){

    function imageComponent(imageSrc) {
        return (
            <div className="flex justify-center">
                <img
                    className="rounded w-2/3"
                    src={imageSrc}/>
            </div>
        )
    }

    return (
        <div>
            <main>
                <section className="container container-wide container-single">
                    <section id="extended-text" className="ns-bio-hero alignfull">
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content">
                                <h1 className="p1 custom-font" style={{lineHeight: "0.9"}}>Before You Start SEO</h1>
                                <p className="p1" style={{'fontSize': '20px'}}>
                                    <strong>TL;DR:</strong> Before beginning any SEO strategy, complete these foundational technical steps:
                                    submit your XML sitemap to Google and Bing, set up a proper robots.txt file, and check Google Search Console to ensure your site has no existing penalties.
                                </p>

                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img decoding="async"
                                     src={Image2}
                                     alt="Professional SEO woman seated working on search engine optimization"/>
                            </figure>
                        </div>
                    </section>
                    <h1 className="wp-block-heading text-2xl sm:text-6xl"
                        id="Build-An-Opportunity-Economy-And-Lower-Costs-For-Families">
                        <strong>1st STEP: CREATE AND SUBMIT AN XML SITEMAP</strong></h1>
                    <p>
                        An XML sitemap helps search engines crawl and index your website's content.
                        It serves as a roadmap, outlining your site's structure and providing important
                        information such as the last time each page was updated. This helps search engines prioritize
                        and index your pages more accurately.&nbsp;
                    </p>
                    {imageComponent("https://www.elegantthemes.com/blog/wp-content/uploads/2022/02/sitemap-seo.png")}
                    <p>
                        Once your sitemap is ready, submit it to both Google Search Console and Bing Webmaster Tools.
                    </p>

                    <p>
                        {imageComponent("https://static.semrush.com/blog/uploads/media/cf/af/cfaf4beea485fdc0e8d9f325b707bdc3/164b248d0b5dbcf0c61a58d1bcbcd0d6/AD_4nXc2adOZ2Cn3FHUeyz9Tzna9UTW7VVgBIkSHvol38NKnMIoWPOMsSPlPXioDRPzCmJu5MoMEWqBwEkYPyqZhHuksizblnFD1z-TX_k5xqrhIDC-M4esOqCzsPJ0jW8B7hjlFzmRJ07WHa5qhtB4jE11Nx1mY.jpeg")}
                        <div>
                            <strong>TIP:</strong> Consider including your sitemap URL within your robots.txt file to
                            assist search engines in locating it.
                        </div>
                    </p>

                    <h1 className="wp-block-heading text-2xl sm:text-6xl" id="Safeguard-Our-Fundamental-Freedoms">
                        <strong>2nd STEP: CREATE A ROBOTS.TXT FILE</strong>&nbsp;&nbsp;</h1>
                    <p>
                        The robots.txt file instructs search engines on which pages and files to crawl and which to
                        avoid.
                        You can use the Google Search Console tool to check and verify that your robots.txt file is
                        correctly configured and accessible.
                    </p>
                    {imageComponent("https://www.keycdn.com/img/support/robots.txt-file.png")}

                    <h2 className="wp-block-heading text-2xl sm:text-5xl" id="Safeguard-Our-Fundamental-Freedoms">
                        <strong>FINAL STEP: Manual Actions</strong>&nbsp;&nbsp;</h2>
                    <p>
                        Any attempt to violate or manipulate Google's webmaster guidelines can result in your site
                        receiving penalties known as manual actions, which can lead to poor or even no rankings.
                        These actions can significantly impact your search rankings, potentially leading to demotions or
                        even complete removal from search results.
                        Common causes include user-generated spam, structured data issues, unnatural links, thin
                        content, hidden text, and scaled content abuse. To avoid these penalties, regularly check your
                        site's status in Google Search Console and promptly address any issues.
                    </p>
                    {imageComponent("https://www.robbierichards.com/wp-content/uploads/2020/02/image20.png")}
                    <div>
                        <strong>NOTE:</strong>&nbsp;Checking for manual actions is a pre-flight check for your site.
                        It's essential to do it before you really start working on anything else.
                    </div>


                    <div className="my-12 mb-24">
                        <MainCTA/>
                    </div>

                    <h3 className="custom-font font-semibold">Frequently Asked Questions</h3>
                    <FaqComponentView faqData={setupFAQs}/>

                </section>
            </main>
        </div>
    )
}